// import appLocaleData from 'react-intl/locale-data/zh';
import enMessages from './lang/en-US.json';
import antdEn from 'antd/lib/locale-provider/en_US'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...enMessages,
  },
  antd: antdEn,
  locale: 'en-US',
  // data: appLocaleData,
};

export default appLocale;
